const headers = {
    name: "Reports",
    components: [
    ],
    navigate: {
        tabs: [
            {
                name: "Reports",
                path: "",
            }
        ],
        total: [
            { value: 0, label: "Total" },
            { value: 0, label: "Active" },
            { value: 0, label: "Inactive" },
        ],
    },
};


export default headers;